import { useState, useEffect, type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { api } from '../api/client'

export function AdminProtectedRoute({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<'loading' | 'admin' | 'denied'>('loading')

  useEffect(() => {
    api
      .get('/admin/me')
      .then(() => setStatus('admin'))
      .catch(() => setStatus('denied'))
  }, [])

  if (status === 'loading') {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: 'var(--cream)',
          fontFamily: 'var(--sans)',
          color: 'var(--ink-muted)',
        }}
      >
        A verificar acesso...
      </div>
    )
  }

  if (status === 'denied') {
    return <Navigate to="/chat" replace />
  }

  return <>{children}</>
}
